import { render, staticRenderFns } from "./ComradesLogo.vue?vue&type=template&id=57d10606"
import script from "./ComradesLogo.vue?vue&type=script&lang=js"
export * from "./ComradesLogo.vue?vue&type=script&lang=js"
import style0 from "./ComradesLogo.vue?vue&type=style&index=0&id=57d10606&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports